import { VueTemplate } from '../VueTemplate';
import { Vue } from '../../../Utility/Vue';
import { ScheduleWidgetTemplateRenderData } from '../../../Widget/ScheduleWidget/types';

/**
 * Template class for Schedule widget created using Vue
 */
export class VueScheduleTemplate extends VueTemplate<ScheduleWidgetTemplateRenderData> {
    /**
     * Expected format of the dataStore
     *
     * All dataStore for Schedule must be of this format so that templates are
     * consistent
     * @see [Vue Prop Validation]{@link https://vuejs.org/v2/guide/components-props.html#Prop-Validation}
     */
    properties: {
        schedule: ArrayConstructor;
        widget: ObjectConstructor;
        metadata: ObjectConstructor;
        Widget: ObjectConstructor;
        wobj: ObjectConstructor;
        viewBag: ObjectConstructor;
    } = {
        schedule: Array, //Array of calendar and its events
        widget: Object, //widget data, could possibly add reference to the widget itself
        metadata: Object, //Other miscellaneous data
        Widget: Object,
        wobj: Object,
        viewBag: Object,
    };

    async render(context: ScheduleWidgetTemplateRenderData): Promise<void> {
        await super.render(context);

        //Run the marquee logic only after the DOM element is created -
        //$nextTick ensures that
        if (this.vueInstance !== null) {
            this.vueInstance.$nextTick(() => {
                this.setupMarquee(context.widget.id);
            });
        }

        // return after next tick so that when render is finished, we know
        // the UI is updated
        return Vue.nextTick();
    }

    /**
     * Check DOM to see if marquee is required
     * @todo: Document the reason for reaching into Vue innards
     *
     * @todo: I needed to add a ton of additional checks for TS.  Ensure they do not block
     *   previously working functionality
     */
    setupMarquee(widgetId: number): void {
        const vueMarqueeChildReference = `vue-marquee-child-${widgetId}`;
        const vueChildReference = this.vueInstance?.$children[0].$refs[vueMarqueeChildReference];
        const vueFirstChildNode =
            vueChildReference && Array.isArray(vueChildReference)
                ? vueChildReference[0]
                : undefined;

        //set marquee metadata as false if content height is less that parent height
        if (
            this.dataStore.metadata.marquee.override ||
            (this.vueInstance &&
                this.vueInstance.$el.parentElement &&
                vueFirstChildNode &&
                vueFirstChildNode instanceof Element &&
                vueFirstChildNode.clientHeight <= this.vueInstance.$el.parentElement.clientHeight)
        ) {
            this.dataStore.metadata.marquee.active = false;
            this.dataStore.metadata.marquee.copy = [1];
            return;
        } else {
            this.dataStore.metadata.marquee.active = true;
            this.dataStore.metadata.marquee.copy = [1, 2, 3, 4, 5, 6, 7];
        }
    }
}
